

export class QASPostalCodeRequest {
  postalCode?: string;
  houseNo?: string;
  unitNo?: string;
  email?: string[];
  requestorEnv?: string;
  requestorId?: string;
  country?: string;
  constructor(initial: any) {
    this.requestorEnv = 'UAT';
    this.requestorId = 'AOL';
    Object.assign(this, initial);
  }
}

export class QASPostalCodeResponse {
  public addressLine1?: string;
  public addressLine2?: string;
  public addressLine3?: string;
  public addressLine4?: string;
  public country?: string;
  public countryCode?: string;
  public postalCode?: string;
  public valid?: false;
  public statusDescription?: string;
  public partialAddress?: boolean;
  constructor(initial: any) {
    Object.assign(this, initial);
  }

}